module.exports = __webpack_public_path__ + "static/img/10.0dbdf4a7.png";